<template>
  <v-app>
    <component :is="layout">
      <router-view :layout.sync="layout"></router-view>
    </component>
    <v-snackbar
      v-model="$store.state.snackbar.show"
      :color="$store.state.snackbar.color"
      :timeout="2000"
      bottom
    >
      {{ $store.state.snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<style>
.no-underline {
  text-decoration: none;
}
</style>

<script>
import store from "@/store/index";
import eventHub from "@/eventhub";
import notificationMixin from "./mixins/notificationMixin";
import sessionMixin from "./mixins/sessionMixin";
export default {
  name: "App",
  mixins: [notificationMixin, sessionMixin],
  computed: {
    layout() {
      return this.$route.meta.layout || this.defaultLayout;
    },
    authUser() {
      return this.getAuthUser();
    },
  },
  created() {
    eventHub.$on("error_503", () => {
      this.failNotification("Servicio no disponible");
    });
    eventHub.$on("error_401", () => {
      this.clear();
      this.$router.go(0);
      this.failNotification("La sesión ha vencido");
    });
  },
  methods: {
    close() {
      store.commit("closeSnackbar");
    },
  },
};
</script>
